import { PaperContainer } from '@Molecules';
import { DefaultButton } from '@Atoms';
import {
	Alert, AlertTitle, List,
} from '@mui/material';
import { ReservationConflict } from '@Types';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface ConflictProps {
	data?: ReservationConflict;
	handleAction?: (action: string) => void;
	loading?: boolean
}

const Conflict: FC<ConflictProps> = (props) => {
	const { data, handleAction, loading } = props;
	const { t } = useTranslation('translations');

	return (
		<PaperContainer>
			<Alert severity="warning">
				<AlertTitle>
					{t('preClosing')}
				</AlertTitle>
				<strong>{t('inconsistenciesFound')}</strong>
				<List sx={{ p: 0 }}>
					<li>{data?.notMatching}</li>
				</List>
				<DefaultButton
					title={t('automaticallyResolveIssues')}
					loading={loading}
					onClick={() => handleAction?.call(0, t('automaticallyResolveIssues'))}
				/>
			</Alert>
		</PaperContainer>
	);
};

export default Conflict;
